import type { FaireBrandEntity } from "../../entity_types/brand";

export const manhattanSnackCo: FaireBrandEntity = {
  token: "manhattan-snack-co",
  type: "brand",
  name: "Manhattan Snack Co.",
  logoUrl:
    "https://cdn.prerelease.faire.dev/fastly/88286f78cad0921e5e4940ca2f4cfc752fa0346cb502a79c1f621d15dec945eb.webp",
  description: "Gourmet snack mixes for sophisticated palates",
  rating: 4.7,
  location: "Manhattan, NY",
  minimumOrderDollars: 125,
  tags: ["gourmet", "premium"],
  categoryTokens: ["cat_food-snacks"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
